// import React from 'react'
import { useState } from 'react'
import { useEffect } from 'react'
import useSWR from 'swr'

export default function useTransaction(params) {
  // const { data: transactions, error, } = useSWR(`transactions?page=${queryParameters.page}&page-size=${queryParameters.page_size}${queryParameters.search ? `&search-query=${queryParameters.search}` : ''}${queryParameters.status ? `&statuses=${queryParameters.status}` : ''}${queryParameters.amount_start ? `&amount-start=${queryParameters.amount_start}` : ''}${queryParameters.amount_end ? `&amount-end=${queryParameters.amount_end}` : ''}${queryParameters.start_date ? `&start-date=${queryParameters.start_date}` : ''}${queryParameters.amount_end ? `&end-date=${queryParameters.end_date}` : ''}`)
  const { data: transactions, error, } = useSWR(`transactions?${params}`)
  const [isLoading, setIsLoading] = useState(false)
  useEffect(() => {
    setIsLoading(true)
    if (transactions || error) {
      setIsLoading(false)
    }
  }, [transactions, error])
  return {
    transactions: transactions?.data.data,
    isLoading: isLoading,
    isError: error,
    first: transactions?.data.first_page_url,
    next: transactions?.data.next_page_url,
    prev: transactions?.data.prev_page_url,
    last: transactions?.data.last_page,
    total: transactions?.data.total,
    current_page: transactions?.data.current_page,
    per_page :  transactions?.data.per_page,
    // rowPerPage: transactions?.data.per_page
  }
}



